import React from 'react';

export default function BoatIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 24.029 21'
      {...props}
    >
      <defs>
        <style>{'.prefix__a{fill:#fff}'}</style>
      </defs>
      <path
        className='prefix__a subheader__container-link-icon'
        d='M14.137 1.215A1.217 1.217 0 0012.922 0h-1.815a1.217 1.217 0 00-1.215 1.215v1.817h4.244zM12.192 7.603l7.044 1.841V4.901a.461.461 0 00-.461-.461H5.253a.461.461 0 00-.461.461v4.543l7.044-1.841a.7.7 0 01.356 0z'
      />
      <path
        className='prefix__a subheader__container-link-icon'
        d='M23.325 19.592a2.971 2.971 0 01-1.571-.4 6.035 6.035 0 00-.69-.306 4.3 4.3 0 00-1.421-.236l2.578-6.489a.429.429 0 00-.294-.564l-9.912-2.59-9.916 2.595a.429.429 0 00-.294.564l2.572 6.488a4.3 4.3 0 00-1.42.238 6.052 6.052 0 00-.685.3 2.972 2.972 0 01-1.571.4.704.704 0 100 1.408 4.33 4.33 0 002.2-.543 4.376 4.376 0 01.588-.258 3.026 3.026 0 01.983-.138c.1 0 .189 0 .274.008a2.949 2.949 0 011.3.387 4.331 4.331 0 002.2.543 4.331 4.331 0 002.2-.543 2.972 2.972 0 011.571-.4 2.971 2.971 0 011.571.4 4.33 4.33 0 002.2.543 4.33 4.33 0 002.2-.543 2.949 2.949 0 011.3-.388c.084-.005.173-.008.268-.008a3.034 3.034 0 01.974.135 4.321 4.321 0 01.6.26 4.33 4.33 0 002.2.543.704.704 0 100-1.408zM5.506 12.615l6.33-1.654a.7.7 0 01.356 0l6.33 1.654a.704.704 0 11-.356 1.362l-6.153-1.608-6.152 1.608a.704.704 0 11-.356-1.362z'
      />
    </svg>
  );
}
